export const types = {
  SET_EQUIPMENT: 'equipmentUsageReport/SET_EQUIPMENT',
  SET_START_DATE: 'equipmentUsageReport/SET_START_DATE',
  SET_END_DATE: 'equipmentUsageReport/SET_END_DATE',
  SET_DATES: 'equipmentUsageReport/SET_DATES',
};

export const setEquipment = (equipment) => {
  return {
    type: types.SET_EQUIPMENT,
    equipment,
  };
};

export const setDates = (startDate, endDate) => {
  return {
    type: types.SET_DATES,
    startDate,
    endDate,
  };
};
